export const ROW_ID_IDX = 0;
export const ISIN_IDX = 1;
export const NAME_IDX = 2;
export const ALIAS_IDX = 3;
export const BID_IDX = 4;
export const ASK_IDX = 5;
export const QUOTE_FEED_IDX = 6;
export const UPDATE_BUTTON_IDX = 8;

export const ROW_ID_COLUMN = "A";
export const ISIN_COLUMN = "B";
export const NAME_COLUMN = "C";
export const ALIAS_COLUMN = "D";
export const BID_COLUMN = "E";
export const ASK_COLUMN = "F";
export const QUOTE_FEED_COLUMN = "G";
export const UPDATE_BUTTON_COLUMN = "I";
export const LAST_BID_SENT_COLUMN = "J";
export const LAST_BID_TIMESTAMP_COLUMN = "K";
export const LAST_ASK_SENT_COLUMN = "L";
export const LAST_ASK_TIMESTAMP_COLUMN = "M";

export const ERROR_SENDING_DATA_FILL_COLOR = "#ff7659";
export const ERROR_SENDING_DATA_FONT_COLOR = "#932912";

export const DISABLED_BUTTON_TO_UPDATE_FILL_COLOR = "#eeeeee";
export const DISABLED_BUTTON_TO_UPDATE_FONT_COLOR = "#bbbbbb";
export const DEFAULT_BUTTON_TO_UPDATE_TEXT = "Update";
export const DEFAULT_BUTTON_TO_RETRY_TEXT = "Retry";
export const ENABLED_BUTTON_TO_UPDATE_TEXT = "Click to Update";

export const DATA_PRODUCER_TABLE_NAME = "SecuritiesTable";
